import { useEffect, useState } from "react";
import { api, oturum, oturumBitince, vekalet, type Kullanici, type Rol } from "./api";
import { Giris } from "./ekranlar/Giris";
import { Pano } from "./ekranlar/Pano";
import { Musteriler } from "./ekranlar/Musteriler";
import { MusteriDetay } from "./ekranlar/MusteriDetay";
import { Kutular } from "./ekranlar/Kutular";
import { Listeler } from "./ekranlar/Listeler";
import { AlanAdlari, Alarmlar, Denetim, Kullanim, Limitler } from "./ekranlar/Digerleri";
import { AlanAdiDetay } from "./ekranlar/AlanAdi";
import { KutuDetay } from "./ekranlar/KutuDetay";
import { Mutabakat } from "./ekranlar/Mutabakat";
import { Guvenlik } from "./ekranlar/Guvenlik";
import { Abonelikler, FaturaDetay, Faturalar, Fiyatlar } from "./ekranlar/Fatura";
import { Kutum } from "./ekranlar/Kutum";
import { Kurulum } from "./ekranlar/Kurulum";
import { Hesabim } from "./ekranlar/Hesabim";
import { Tasima } from "./ekranlar/Tasima";
import { DurumSayfasi } from "./ekranlar/DurumSayfasi";
import { ParolaKur } from "./ekranlar/ParolaKur";
import { useCek } from "./ui";
import { Logo, UrunAdi } from "./marka";
import { Simge, YOL_SIMGE } from "./simgeler";

/** Marka kiti koyu temayi [data-theme="dark"] ile tanimliyor */
function temaDegistir(): "acik" | "koyu" {
  const simdiki = document.documentElement.getAttribute("data-theme");
  const yeni = simdiki === "dark" ? "light" : "dark";
  document.documentElement.setAttribute("data-theme", yeni);
  try {
    localStorage.setItem("panelim.tema", yeni === "dark" ? "koyu" : "acik");
  } catch {
    /* gizli sekme */
  }
  return yeni === "dark" ? "koyu" : "acik";
}

/** Kucuk hash yonlendirici — ayri bir kutuphaneye deger bir karmasiklik yok. */
function yolOku(): string {
  const h = window.location.hash.replace(/^#/, "");
  return h || "/";
}

/**
 * Menu role gore suzulur. Bir musteri operator ekranlarini goremez —
 * sunucu zaten 403 doner, bu yalnizca kullaniciya olmayan kapiyi gostermemek icin.
 */
/**
 * ozellik: bu madde yalnizca ilgili ozellik ACIKSA gorunur.
 * Ticari katman kapatilabilir oldugu icin menude de kaybolmali; aksi hâlde
 * kullanici calismayan bir bolume girer.
 */
const MENU: Array<{ yol: string; ad: string; bolum?: string; roller: Rol[]; ozellik?: "ticari" }> = [
  { yol: "/", ad: "Pano", bolum: "Yönetim", roller: ["operator", "musteri"] },
  { yol: "/musteriler", ad: "Müşteriler", roller: ["operator"] },
  { yol: "/alanadlari", ad: "Alan adları", roller: ["operator", "musteri"] },
  { yol: "/kutular", ad: "Posta kutuları", roller: ["operator", "musteri"] },
  { yol: "/listeler", ad: "Dağıtım listeleri", roller: ["operator", "musteri"] },
  { yol: "/kurulum", ad: "E-posta kurulumu", roller: ["operator", "musteri"] },
  { yol: "/tasima", ad: "Posta taşıma", roller: ["operator", "musteri"] },
  { yol: "/faturalar", ad: "Faturalar", bolum: "Ticari", roller: ["operator", "musteri"], ozellik: "ticari" },
  { yol: "/abonelikler", ad: "Abonelikler", roller: ["operator"], ozellik: "ticari" },
  { yol: "/fiyatlar", ad: "Fiyatlar", roller: ["operator"], ozellik: "ticari" },
  { yol: "/limitler", ad: "Limitler", bolum: "İzleme", roller: ["operator"] },
  { yol: "/kullanim", ad: "Kullanım", roller: ["operator", "musteri"] },
  { yol: "/guvenlik", ad: "Güvenlik", roller: ["operator", "musteri"] },
  { yol: "/mutabakat", ad: "Mutabakat", roller: ["operator"] },
  { yol: "/alarmlar", ad: "Alarmlar", roller: ["operator", "musteri"] },
  { yol: "/denetim", ad: "İşlem geçmişi", roller: ["operator", "musteri"] },
  { yol: "/hesabim", ad: "Hesabım", bolum: "Hesap", roller: ["operator", "musteri"] },
];

export function App() {
  const [yol, setYol] = useState(yolOku);
  const [kullanici, setKullanici] = useState<Kullanici | null>(oturum.kullanici());
  // Kucuk ekranda menu cekmecesi. Buyuk ekranda CSS bu durumu yoksayar.
  const [menuAcik, setMenuAcik] = useState(false);
  // Hangi bolumlerin acik oldugunu sunucu soyler (/saglik).
  const saglik = useCek(() => api.saglik(), []);
  const ticariAcik = saglik.veri?.ozellikler?.ticari !== false;
  const [tema, setTema] = useState<"acik" | "koyu">(
    document.documentElement.getAttribute("data-theme") === "dark" ? "koyu" : "acik",
  );
  // Hangi kapidayiz: tarafsiz adres mi, bir musterinin kendi adresi mi
  const konak = useCek(() => api.konak(), []);
  // Vekaleten calisiliyorsa kimin adina
  const [vk, setVk] = useState(() => vekalet.simdiki());

  useEffect(() => {
    const f = () => setYol(yolOku());
    window.addEventListener("hashchange", f);
    return () => window.removeEventListener("hashchange", f);
  }, []);

  useEffect(() => {
    oturumBitince(() => setKullanici(null));
  }, []);

  // Musterinin kendi kapisinda sekme basligi da onun adini tasisin
  useEffect(() => {
    const k = konak.veri?.veri;
    if (k?.kiraci && k.ad) document.title = k.ad + " · Posta Paneli";
  }, [konak.veri]);

  function git(y: string) {
    window.location.hash = y;
    setYol(y);
    // Telefonda bir menu maddesine basinca cekmece kapanmalı; aksi hâlde
    // kullanici acilan sayfayi gormek icin menuyu elle kapatmak zorunda kalir.
    setMenuAcik(false);
  }

  // Durum sayfasi kimlik istemez: musteri giris yapamadiginda da bakabilmeli.
  if (yol === "/durum") return <DurumSayfasi />;
  // Kimlik ISTEMEYEN ikinci yol. Giris denetiminin USTUNDE durmali:
  // buraya gelen kullanicinin daha parolasi yok, giris ekranina
  // dusurulurse kurulumu hic tamamlayamaz.
  if (yol.startsWith("/parola-kur/")) {
    return <ParolaKur jeton={decodeURIComponent(yol.slice("/parola-kur/".length))} />;
  }

  if (!kullanici)
    return (
      <Giris
        girdi={() => setKullanici(oturum.kullanici())}
        konakAd={konak.veri?.veri.kiraci ? konak.veri.veri.ad : null}
      />
    );

  /**
   * VEKÂLET ŞERİDİ
   *
   * Ekranin en ustunde, kapatilamaz ve gorulmemesi imkânsiz. Sebebi:
   * operatorun hangi sapkayi taktigini unutmasi, bu ozelligin tek gercek
   * tehlikesi. Serit dururken yapilan her islem musterinin kaydina yazilir
   * — ama denetimde kisi olarak OPERATOR gorunur.
   */
  const VekaletSeridi = () =>
    vk ? (
      <div className="vekalet-serit" role="status">
        <span>
          <b>{vk.ad}</b> gözüyle bakıyorsunuz. Yaptığınız işlemler bu müşterinin
          kaydına, sizin adınıza yazılır.
        </span>
        <button
          onClick={() => {
            vekalet.bitir();
            setVk(null);
            git("/musteriler");
          }}
        >
          Kendi hesabıma dön
        </button>
      </div>
    ) : null;

  // Posta kutusu sahibinin tek bir ekrani vardir; menuye gerek yok.
  if (kullanici.rol === "kutu") {
    return (
      <div className="uygulama tek">
        <main className="govde">
          <div className="kutum-ust">
            <Logo boyut={22} />
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <button className="dugme kucuk" onClick={() => setTema(temaDegistir())}>
                {tema === "koyu" ? "Açık tema" : "Koyu tema"}
              </button>
              <button
                className="dugme kucuk"
                onClick={async () => {
                  await api.cikis();
                  setKullanici(null);
                }}
              >
                <Simge ad="cikis" boyut={15} />
                <Simge ad="cikis" boyut={15} />
            Çıkış
              </button>
            </div>
          </div>
          <Kutum />
        </main>
      </div>
    );
  }

  return (
    <div className="uygulama">
      <aside className={"yan" + (menuAcik ? " acik" : "")}>
        <div className="marka">
          <Logo boyut={24} koyuZemin />
          {/* Musterinin kendi kapisinda urunun degil KURUMUN adi yazar */}
          {konak.veri?.veri.kiraci && konak.veri.veri.ad ? (
            <span className="konak-ad">{konak.veri.veri.ad}</span>
          ) : (
            <UrunAdi koyuZemin />
          )}
          {/* Yalnizca kucuk ekranda gorunur (CSS ile) */}
          <button
            className="menu-dugmesi"
            onClick={() => setMenuAcik((v) => !v)}
            aria-expanded={menuAcik}
            aria-label={menuAcik ? "Menüyü kapat" : "Menüyü aç"}
          >
            <Simge ad={menuAcik ? "carpi" : "menu"} boyut={18} />
            {menuAcik ? "Kapat" : "Menü"}
          </button>
        </div>
        <nav>
          {MENU.filter((m) => m.roller.includes(vk ? "musteri" : kullanici.rol))
            .filter((m) => m.ozellik !== "ticari" || ticariAcik)
            .map((m) => (
            <div key={m.yol}>
              {m.bolum && <div className="bolum">{m.bolum}</div>}
              <a
                href={"#" + m.yol}
                className={yol === m.yol || (m.yol !== "/" && yol.startsWith(m.yol)) ? "etkin" : ""}
                onClick={(e) => {
                  e.preventDefault();
                  git(m.yol);
                }}
              >
                <span className="menu-ad">
                  <Simge ad={YOL_SIMGE[m.yol] ?? "pano"} boyut={17} />
                  <span>{m.ad}</span>
                </span>
                {kullanici.rol === "operator" && <Sayac yol={m.yol} />}
              </a>
            </div>
          ))}
        </nav>
        <div className="alt">
          <div>
            <div className="kim">{kullanici.ad ?? kullanici.eposta}</div>
            <div className="rol">
              {vk
                ? "vekâleten: " + vk.ad
                : kullanici.rol === "operator"
                  ? "operatör"
                  : "müşteri paneli"}
            </div>
          </div>
          <button onClick={() => setTema(temaDegistir())}>
            <Simge ad={tema === "koyu" ? "gunes" : "ay"} boyut={15} />
            {tema === "koyu" ? "Açık tema" : "Koyu tema"}
          </button>
          <button
            onClick={async () => {
              await api.cikis();
              setKullanici(null);
            }}
          >
            <Simge ad="cikis" boyut={15} />
            Çıkış
          </button>
        </div>
      </aside>

      <main className="govde">
        <VekaletSeridi />
        {/* Vekaleten calisirken ekranlar da musteri rolunu gormeli */}
        <Ekran yol={yol} git={git} rol={vk ? "musteri" : kullanici.rol} ticariAcik={ticariAcik} />
      </main>
    </div>
  );
}

/** Menude dikkat isteyen sayilar — alarm ve kilitli kutu */
function Sayac({ yol }: { yol: string }) {
  const alarmlar = useCek(() => api.alarmlar(), []);
  const kilitli = useCek(() => api.kilitliler(), []);
  const n =
    yol === "/alarmlar"
      ? alarmlar.veri?.veri.length ?? 0
      : yol === "/limitler"
        ? kilitli.veri?.veri.length ?? 0
        : 0;
  if (!n) return null;
  return (
    <span
      style={{
        background: "var(--brand)",
        color: "#fff",
        borderRadius: "var(--r-pill)",
        padding: "1px 7px",
        fontSize: 11,
        fontWeight: 700,
      }}
    >
      {n}
    </span>
  );
}

function Ekran({
  yol,
  git,
  rol,
  ticariAcik,
}: {
  yol: string;
  git: (y: string) => void;
  rol: Rol;
  ticariAcik: boolean;
}) {
  // Menude gizlemek yetmez: adres cubuguna elle yazilabilir.
  const ticariKapali = !ticariAcik && /^\/(faturalar|abonelikler|fiyatlar)/.test(yol);
  if (ticariKapali) {
    return (
      <div className="baslik">
        <div>
          <h1>Bu bölüm kapalı</h1>
          <p>
            Abonelik ve faturalama şu an kullanılmıyor. Açmak için sunucuda{" "}
            <code>TICARI_ETKIN=evet</code> yapıp paneli yeniden başlatın.
          </p>
          <p>
            <a href="#/">← Panoya dön</a>
          </p>
        </div>
      </div>
    );
  }
  if (yol === "/") return <Pano git={git} rol={rol} />;
  if (yol === "/musteriler") return <Musteriler git={git} />;
  if (yol.startsWith("/musteriler/")) return <MusteriDetay id={yol.slice("/musteriler/".length)} git={git} />;
  if (yol === "/alanadlari") return <AlanAdlari git={git} rol={rol} />;
  if (yol.startsWith("/alanadlari/")) return <AlanAdiDetay id={yol.slice("/alanadlari/".length)} git={git} />;
  if (yol === "/kutular") return <Kutular git={git} rol={rol} />;
  if (yol === "/listeler") return <Listeler />;
  if (yol.startsWith("/kutular/")) return <KutuDetay id={yol.slice("/kutular/".length)} git={git} />;
  if (yol === "/kurulum") return <Kurulum />;
  if (yol === "/tasima") return <Tasima />;
  if (yol === "/faturalar") return <Faturalar git={git} rol={rol} />;
  if (yol.startsWith("/faturalar/")) return <FaturaDetay id={yol.slice("/faturalar/".length)} git={git} rol={rol} />;
  if (yol === "/abonelikler") return <Abonelikler git={git} />;
  if (yol === "/fiyatlar") return <Fiyatlar />;
  if (yol === "/limitler") return <Limitler />;
  if (yol === "/kullanim") return <Kullanim />;
  if (yol === "/guvenlik") return <Guvenlik />;
  if (yol === "/mutabakat") return <Mutabakat />;
  if (yol === "/alarmlar") return <Alarmlar />;
  if (yol === "/denetim") return <Denetim />;
  if (yol === "/hesabim") return <Hesabim />;
  return (
    <div className="baslik">
      <div>
        <h1>Sayfa bulunamadı</h1>
        <p>
          <a href="#/">Genel bakışa dön</a>
        </p>
      </div>
    </div>
  );
}
